import { SxProps, Theme } from "@mui/material";
import { borderRadius } from "themes/constants";

export const root: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
});

export const header: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: theme.spacing(2),
});

export const headerInfo: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
});

export const image: SxProps<Theme> = (theme) => ({
  width: "160px",
  height: "160px",
  objectFit: "cover",
  borderRadius,
});

export const content: SxProps<Theme> = (theme) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  alignItems: "flex-start",
});

export const side: SxProps<Theme> = (theme) => ({
  display: "flex",
  width: "100%",
});

export const description: SxProps<Theme> = (theme) => ({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  gap: theme.spacing(2),
  flexWrap: "wrap",
  "& *": { wordBreak: "break-word" },
});

export const singleRowDescription: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(2),
  flexWrap: "wrap",
  "& *": { wordBreak: "break-word" },
});

export const buttonContainer: SxProps<Theme> = (theme) => ({
  display: "flex",
});

export const firstDivider: SxProps<Theme> = (theme) => ({
  width: "100%",
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(2),
});

export const divider: SxProps<Theme> = (theme) => ({
  width: "100%",
  marginY: theme.spacing(2),
});
